export default "__VITE_ASSET__DsA35t21__"